import { Storage } from '@ionic/storage';
import { Inject, Injectable } from "@angular/core";
import { LoopBackAuth } from '../sdk';

@Injectable()
export class RecruitmentAuth {

    private stringToken = 'token';
    private stringRecruitment = 'authRecruitment';
    private stringAccessMode = 'accessMode';
    private stringKey = 'key';
    private stringProfileId = 'profile';

    constructor(
        private storage: Storage,
        @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    ) { }

    /**
     * Auth
     */
    getAuthRecruitment(): Promise<any> {
        return new Promise(async resolve => {
            try {
                await this.storage.ready();
                const auth = await this.storage.get(this.stringRecruitment);
                this.setAccessToken(auth.token);
                resolve(auth);
            } catch (error) {
                resolve(null);
            }
        })
    }

    setAuthRecruitment(data: any): Promise<any> {
        return new Promise(async resolve => {
            try {
                await this.storage.ready();
                await this.storage.set(this.stringRecruitment, data.data.token);
                this.setAccessToken(data.data.token);
                this.setAccessMode('jobseeker');
                if (data.data.personalInfo) {
                    this.setProfileId(data.data.personalInfo);
                }
                resolve(true);
            } catch (error) {
                resolve(null);
            }
        })
    }

    loadAuthRecruitment() {
        return new Promise(async resolve => {
            try {
                await this.storage.ready();
                const data = JSON.parse(await this.storage.get('SFGoAuth'));
                this.setAccessToken(data.id);
                this.setAccessMode('jobseeker');
                this.auth.setToken(data);
                this.auth.save();
                resolve(true);
            } catch (error) {
                resolve(null);
            }
        })
    }

    public setProfileId(data: any): boolean {
        localStorage.setItem(this.stringProfileId, data.id);
        return true;
    }

    public setAccessToken(token: string): boolean {
        localStorage.setItem(this.stringToken, token);
        return true;
    }

    public getAccessToken(): string {
        return localStorage.getItem(this.stringToken);
    }

    public setAccessMode(data: string): boolean {
        localStorage.setItem(this.stringAccessMode, data);
        return true;
    }

    public getKey(): string {
        return localStorage.getItem(this.stringKey);
    }

    public setKey(data: string): boolean {
        localStorage.setItem(this.stringKey, data);
        return true;
    }

    public isRecruitment(): boolean {
        return (localStorage.getItem(this.stringAccessMode) == 'jobseeker') ? true : false;
    }

    public isRegistered(): boolean {
        return (localStorage.getItem(this.stringProfileId)) ? true : false;
    }

    public getPath(): string {
        const key = this.getKey();
        return (key.includes('dev-')) ? 'stagingrecruitment' : 'recruitment';
    }

    public async clearStorage() {
        await this.storage.ready();
        await this.storage.clear();
        localStorage.removeItem(this.stringToken);
        localStorage.removeItem(this.stringAccessMode);
        localStorage.removeItem(this.stringProfileId);
        localStorage.removeItem(this.stringKey);
        return true;
    }

}


// WEBPACK FOOTER //
// ./src/shared/recruitment/recruitment-auth.ts